/**
 * Shared helpers for the customer-facing support apps.
 * Manages magic-link session in localStorage + authed fetch.
 */

const STORAGE_KEY = 'ast_support_session';
export const cfg = (typeof window !== 'undefined' && window.astSupportConfig) || {};

export function loadSession() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.session_token) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function saveSession(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
    catch (e) { console.warn('localStorage write failed', e); }
}

export function clearSession() {
    try { localStorage.removeItem(STORAGE_KEY); }
    catch { /* ignore */ }
}

/** Fetch wrapper that adds the magic-link session header. */
export async function authedFetch(path, options = {}) {
    const session = loadSession();
    const headers = {
        Accept: 'application/json',
        ...(options.headers || {}),
    };
    if (session?.session_token) {
        headers['X-AST-Session'] = session.session_token;
    }
    if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
        options = { ...options, body: JSON.stringify(options.body) };
    }
    const res = await fetch(`${cfg.apiUrl}${path}`, { ...options, headers });
    if (res.status === 401) {
        clearSession();
        throw new Error('Sessie verlopen. Log opnieuw in via uw e-mail-link.');
    }
    const body = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(body?.message || `HTTP ${res.status}`);
    }
    return body;
}

export async function uploadFile(path, file, extra = {}) {
    const session = loadSession();
    const fd = new FormData();
    fd.append('file', file);
    Object.entries(extra).forEach(([k, v]) => fd.append(k, String(v)));
    const headers = {};
    if (session?.session_token) headers['X-AST-Session'] = session.session_token;
    const res = await fetch(`${cfg.apiUrl}${path}`, {
        method: 'POST',
        body: fd,
        headers,
    });
    const body = await res.json().catch(() => null);
    if (!res.ok) throw new Error(body?.message || `HTTP ${res.status}`);
    return body;
}
